import type { ReactNode } from 'react';
import { useAuthStore } from '@/stores/auth';
import type { RoleId } from '@/data/roles';
import type { AuthUser } from '@/stores/auth';

type AssociationRole = NonNullable<AuthUser['association_role']>;
type Props = { allow: RoleId[]; associationRoles?: AssociationRole[]; fallback?: ReactNode; children: ReactNode };

export const canAccessRole = (user: AuthUser | null, allow: RoleId[], associationRoles?: AssociationRole[]): boolean => {
  if (!user || !allow.includes(user.role)) return false;
  if (user.role !== 'assoc' || !associationRoles) return true;

  return associationRoles.includes(user.association_role ?? 'staff');
};

export const RoleGate = ({ allow, associationRoles, fallback = null, children }: Props) => {
  const user = useAuthStore((state) => state.user);
  return <>{canAccessRole(user, allow, associationRoles) ? children : fallback}</>;
};
